import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import axios from "../../AxiosClient";
import Card from "@material-ui/core/Card";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import SourceTypeSelector from "./pages/SourceTypeSelector";
import BasicSettings from "./pages/BasicSettings";
import AdvancedSettings from "./pages/AdvancedSettings";
import ConfirmPage from "./pages/ConfirmPage";
import AuthorisationPage from "./pages/AuthorisationPage";
import DonePage from "./pages/DonePage";
import { withRouter } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Alert from "@material-ui/lab/Alert";
import { documentLimitReached } from "../../utils/LicenceUtils";
import AddKSToSchedule from "./pages/AddKSToSchedule";
import { getClientId } from "../../utils/OAuthClientData";

const styles = (theme) => ({
  stepper: {
    marginBottom: 20,
  },
  dialogContainer: {
    display: "flex",
    flexDirection: "column",
    overflowY: "hidden",
  },
  modalAppBar: {
    position: "relative",
  },
  modalToolbar: {
    paddingLeft: 0,
  },
});
export class CreateKnowledgeSource extends Component {
  state = {
    activeStep: 0,
    classification: 0,
    sourceType: "",
    description: "",
    topic: "",
    knowledgeSourceId: 0,
    presentationProperties: {},
    readerProperties: {},
    reindexerProperties: {},
    sourceProperties: {},
    spiderProperties: {},
    url: "",
    wasReindex: false,
    key: 1,
    editKs: null,
    scheduleIds: [],
    clientId: null,
  };
  getCoreElement = () => {
    const { classes } = this.props;
    return (
      <div
        style={{
          overflow: "auto",
          padding: 10,
          height: "100%",
          backgroundColor: "#eae0d7",
          backgroundImage: "url('../../images/background.svg')",
        }}
      >
        <div>
          {documentLimitReached() && (
            <Alert
              severity="error"
              style={{ width: "50%", margin: "0px auto 10px auto" }}
            >
              <Trans i18nKey="create_ks_document_limit_reached" />
            </Alert>
          )}
        </div>
        <Card className={classes.stepper}>
          <Stepper activeStep={this.state.activeStep}>
            <Step completed={this.state.activeStep > 0}>
              <StepLabel>
                <Trans i18nKey="create_ks_stepper_select_source_type" />
              </StepLabel>
            </Step>
            <Step completed={this.state.activeStep > 1}>
              <StepLabel>
                <Trans i18nKey="create_ks_stepper_basic_settings" />
              </StepLabel>
            </Step>
            <Step completed={this.state.activeStep > 2}>
              <StepLabel
                optional={
                  <Typography variant="caption">
                    <Trans i18nKey="global_optional" />
                  </Typography>
                }
              >
                <Trans i18nKey="create_ks_add_ks_to_schedule" />
              </StepLabel>
            </Step>
            <Step completed={this.state.activeStep > 3}>
              <StepLabel
                optional={
                  <Typography variant="caption">
                    <Trans i18nKey="global_optional" />
                  </Typography>
                }
              >
                <Trans i18nKey="create_ks_stepper_advanced_settings" />
              </StepLabel>
            </Step>
            <Step completed={this.state.activeStep > 4}>
              <StepLabel>
                <Trans i18nKey="create_ks_stepper_verify_save" />
              </StepLabel>
            </Step>
            {this.needsAuth() && (
              <Step completed={this.state.activeStep > 5}>
                <StepLabel>
                  <Trans i18nKey="create_ks_stepper_authorise" />
                </StepLabel>
              </Step>
            )}
          </Stepper>
        </Card>
        <SourceTypeSelector
          key={1 * this.state.key}
          show={this.state.activeStep === 0}
          onSelectSource={this.onSelectSource}
          style={{ display: this.state.activeStep === 0 ? "block" : "none" }}
          setClientId={(clientId) => this.setState({ clientId })}
        />
        <BasicSettings
          key={2 * this.state.key}
          show={this.state.activeStep === 1}
          back={this.back}
          next={this.next}
          nextText={
            this.isEdit() && this.state.sourceType === "EXPERT"
              ? "Save"
              : "Next"
          }
          sourceType={this.state.sourceType}
          setSpiderProperties={this.setSpiderProperties}
          setSourceProperties={this.setSourceProperties}
          setReaderProperties={this.setReaderProperties}
          updateURL={this.updateURL}
          updateDescription={this.updateDescription}
          updateTopic={this.updateTopic}
          updateClassification={this.updateClassification}
          topic={this.props.topic}
          topicName={this.props.topicName}
          editKs={this.state.editKs}
        />
        <AddKSToSchedule
          key={3 * this.state.key}
          show={this.state.activeStep === 2}
          back={this.back}
          next={this.next}
          nextText={
            this.isEdit() && this.state.sourceType === "EXPERT"
              ? "Save"
              : "Next"
          }
          showSkipButton
          scheduleIds={this.updateScheduleIds}
        />
        <AdvancedSettings
          key={4 * this.state.key}
          show={this.state.activeStep === 3}
          back={this.back}
          next={this.next}
          sourceType={this.state.sourceType}
          showSkipButton
          setSpiderProperties={this.setSpiderProperties}
          setSourceProperties={this.setSourceProperties}
          setReaderProperties={this.setReaderProperties}
          editKs={this.state.editKs}
        />
        <ConfirmPage
          key={5 * this.state.key}
          show={this.state.activeStep === 4}
          back={this.back}
          next={this.save}
          nextText="Save"
          needsAuth={this.needsAuth()}
          showReindexButtons={!this.needsAuth()}
          properties={{
            spiderProperties: this.state.spiderProperties,
            readerProperties: this.state.readerProperties,
            sourceProperties: this.state.sourceProperties,
            presentationProperties: this.state.presentationProperties,
            reindexerProperties: this.state.reindexerProperties,
          }}
          url={this.getSourceUrl()}
          sourceType={this.state.sourceType}
          authOnDomain={this.isAuthOnDomain()}
          reindex={this.saveReindex}
          editKs={this.state.editKs}
          clientId={this.state.clientId}
        />
        <AuthorisationPage
          key={6 * this.state.key}
          show={this.state.activeStep === 5}
          back={this.back}
          sourceType={this.state.sourceType}
          knowledgeSourceId={this.state.knowledgeSourceId}
          showReindexButtons
          description={this.state.description}
          nextText={this.props.t("global_finish")}
          authOnDomain={this.isAuthOnDomain()}
          next={this.next}
          reindex={this.reindex}
          editKs={this.state.editKs}
          onAuth={this.next}
          clientId={this.state.clientId}
        />
        <DonePage
          key={this.state.key}
          show={this.state.activeStep === 6}
          isEnd
          restart={this.restart}
          description={this.state.description}
          wasReindex={this.state.wasReindex}
          editKs={this.state.editKs}
          restartText={this.isEdit() ? this.props.t("go_back") : null}
        />
      </div>
    );
  };
  componentDidMount() {
    this.props.topic && this.setState({ topic: this.props.topic });
    if (this.isEdit()) {
      this.setState({ activeStep: 1 });
      this.setState({ editKs: true }, () => {
        axios
          .get(`/knowledgesource/${this.props.location.state.ksId}`)
          .then((res) => {
            this.setState(
              {
                editKs: res.data,
                sourceType: res.data.type,
              },
              () => {
                getClientId(this.state.sourceType, this.onClientIdReponse);
              }
            );
          });
      });
    }
  }
  onClientIdReponse = (response) => {
    this.setState({ clientId: response.res.data });
  };
  componentDidUpdate(prevProps, prevState) {
    this.props.topic !== prevProps.topic &&
      this.setState({ topic: this.props.topic });
    if (
      this.state.editKs &&
      (!this.props.location ||
        !this.props.location.state ||
        !this.props.location.state.edit ||
        !this.props.location.state.ksId)
    ) {
      this.setState({
        editKs: null,
      });
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <>
        {this.props.asDialog === true ? (
          <Dialog
            fullScreen
            open={this.props.open ? this.props.open : true}
            onClose={this.props.handleClose}
            classes={{ paper: classes.dialogContainer }}
          >
            <AppBar className={classes.modalAppBar}>
              <Toolbar className={classes.modalToolbar}>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={this.props.handleClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  {this.props.topicName
                    ? "Create Knowledge Source for " + this.props.topicName
                    : "Create Knowledge Source"}
                </Typography>
              </Toolbar>
            </AppBar>
            {this.getCoreElement()}
          </Dialog>
        ) : (
          this.getCoreElement()
        )}
      </>
    );
  }

  isAuthOnDomain = () => {
    return !!this.state.spiderProperties.authOnDomain;
  };

  restart = () => {
    if (this.isEdit()) {
      this.props.history.goBack();
    } else {
      this.setState({
        activeStep: 0,
        wasReindex: false,
        key: this.state.key + 1,
        classification: 0,
        sourceType: "",
        description: "",
        topic: "",
        knowledgeSourceId: 0,
        properties: {},
        url: "",
      });
    }
  };

  updateScheduleIds = (ids) => {
    this.setState({ scheduleIds: ids });
  };

  updateURL = (url) => {
    this.setState({ url });
  };

  updateDescription = (description) => {
    this.setState({ description });
  };
  updateTopic = (topic) => {
    this.setState({ topic });
  };

  updateClassification = (classification) => {
    this.setState({ classification });
  };

  onSelectSource = (sourceType) => {
    this.setState({ activeStep: this.state.activeStep + 1, sourceType });
  };

  setSpiderProperties = (spiderProperties) => {
    this.setState({
      spiderProperties: { ...this.state.spiderProperties, ...spiderProperties },
    });
  };

  setSourceProperties = (sourceProperties) => {
    this.setState({
      sourceProperties: { ...this.state.sourceProperties, ...sourceProperties },
    });
  };

  setReaderProperties = (readerProperties) => {
    this.setState({
      readerProperties: { ...this.state.readerProperties, ...readerProperties },
    });
  };

  setBasicSettings = (basicSettings) => {
    this.setState({
      basicSettings,
      settings: basicSettings.concat(this.state.advancedSettings),
    });
  };

  setAdvancedSettings = (advancedSettings) => {
    this.setState({
      advancedSettings,
      settings: this.state.basicSettings.concat(advancedSettings),
    });
  };

  reindex = (isFullReindex) => {
    this.setState({ wasReindex: true });
    axios.post(
      `/knowledgesource/${
        this.state.knowledgeSourceId
      }/reindex?isFullReindex=${isFullReindex}`
    );
    this.setState({ activeStep: this.state.activeStep + 1 });
  };

  saveReindex = (isFullReindex) => {
    this.setState({ wasReindex: true });
    this.save(() => {
      axios.post(
        `/knowledgesource/${
          this.state.knowledgeSourceId
        }/reindex?isFullReindex=${isFullReindex}`
      );
    });
  };

  save = (callback) => {
    if (this.state.sourceType !== "EXPERT") {
      if (!this.needsAuth()) {
        this.setState({ activeStep: this.state.activeStep + 2 });
      } else {
        this.setState({ activeStep: this.state.activeStep + 1 });
      }
    }
    if (this.isEdit()) {
      axios
        .patch(`/knowledgesource/${this.state.editKs.sourceId}`, {
          description: this.state.description,
          url: this.getSourceUrl(),
          properties: {
            spiderProperties: this.state.spiderProperties,
            readerProperties: this.state.readerProperties,
            sourceProperties: this.state.sourceProperties,
            presentationProperties: this.state.presentationProperties,
            reindexerProperties: this.state.reindexerProperties,
          },
        })
        .then((res) => {
          this.setState({ knowledgeSourceId: res.data.sourceId }, () => {
            if (callback) {
              callback();
            }
          });
        });
    } else {
      axios
        .post("/knowledgesource/", {
          communityId: 1001,
          description: this.state.description,
          url: this.getSourceUrl(),
          properties: {
            spiderProperties: this.state.spiderProperties,
            readerProperties: this.state.readerProperties,
            sourceProperties: this.state.sourceProperties,
            presentationProperties: this.state.presentationProperties,
            reindexerProperties: this.state.reindexerProperties,
          },
          topicId: this.state.topic,
          classification: this.state.classification,
          type: this.state.sourceType,
        })
        .then((res) => {
          this.setState({ knowledgeSourceId: res.data.sourceId }, () => {
            if (this.state.scheduleIds.length > 0) {
              axios.patch("/knowledgesource/batchreindex/createks", {
                scheduleIds: this.state.scheduleIds,
                knowledgeSourceId: res.data.sourceId,
              });
            }
            if (callback) {
              callback();
            }
          });
        });
    }
  };

  isEdit = () => {
    return (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.edit &&
      this.props.location.state.ksId
    );
  };

  getSourceUrl = () => {
    switch (this.state.sourceType) {
      case "GOOGLE_DRIVE":
        return "drive.google.com";
      case "DROPBOX":
        return "dropbox.com";
      case "SALESFORCE":
        return "salesforce.com";
      case "EXPERT":
        return "universal://localhost:8888/ks/";
      default:
        return this.state.url;
    }
  };

  needsAuth = () => {
    return (
      this.state.sourceType === "SHAREPOINT" ||
      this.state.sourceType === "ONEDRIVE" ||
      this.state.sourceType === "GOOGLE_DRIVE" ||
      this.state.sourceType === "DROPBOX" ||
      this.state.sourceType === "SALESFORCE"
    );
  };

  back = () => {
    if (this.isEdit() && this.state.activeStep === 1) {
      this.props.history.goBack();
    }
    //  else if (this.isEdit() && this.state.activeStep === 5) {
    //   this.setState({ activeStep: 1 });
    // }
    else if (this.isEdit() && this.state.activeStep === 3) {
      this.setState({ activeStep: 1 });
    } else {
      this.setState({ activeStep: this.state.activeStep - 1 });
    }
  };

  next = () => {
    if (this.isEdit() && this.state.activeStep === 1) {
      if (this.state.sourceType === "EXPERT") {
        this.save(() => {
          // this.setState({ activeStep: 5 });
          this.props.history.goBack();
        });
      } else {
        this.setState({ activeStep: 3 });
      }
    } else if (
      this.state.sourceType === "EXPERT" &&
      this.state.activeStep === 1
    ) {
    } else {
      this.setState({ activeStep: this.state.activeStep + 1 });
    }
  };

  selectSourceType = (sourceType) => {
    this.setState({ activeStep: this.state.activeStep + 1, sourceType });
  };
}

export default withTranslation()(
  withStyles(styles)(withRouter(CreateKnowledgeSource))
);
